import React from 'react'
import IconArrowRight from '@/icons/navigation/iconArrowRight'
import locales from '../../helpers/locales'
import * as styles from './BannerJobsOpenings.css'

const href = 'https://carreira.inhire.com.br/carreiras/carreiras-sympla'

type BannerJobsOpeningsProps = {
  lang?: 'pt' | 'en' | 'es'
  onClick?: () => void
}

export function BannerJobsOpenings({
  lang = 'pt',
  onClick,
}: BannerJobsOpeningsProps) {
  const { TITLE, BADGE, CTA } = locales[lang].BANNERJOBSOPENINGS

  return (
    <a className={styles.Root} href={href} onClick={onClick} aria-label={TITLE}>
      <div className={styles.Container}>
        <div className={styles.Inner}>
          <div className={styles.Content}>
            <span className={styles.Badge}>{BADGE}</span>
            <h3 className={styles.Title}>{TITLE}</h3>
          </div>

          <div className={styles.CtaWrapper}>
            <div className={styles.Cta}>
              <span className={styles.CtaText}>{CTA}</span>
              <IconArrowRight className={styles.Icon} />
            </div>
          </div>
        </div>
      </div>
    </a>
  )
}

export default BannerJobsOpenings
